import React from 'react';
import LogoText from '../../../../images/logo-text.png';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Link from '@material-ui/core/Link';
import { HOME, SIGN_UP } from '../../../front/routing';
import ServiceButton from './ServiceButton';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',

    padding: theme.spacing(0),
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
      flexDirection: 'row',
    },
  },
  logoText: {
    width: 160,
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      width: 135,
      padding: theme.spacing(0),
    },
  },
  buttonContainer: {
    display: 'flex',

    justifyContent: 'space-evenly',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-start',
      marginBottom: theme.spacing(0),
    },
  },
  buttonLeft: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(2),
    },
  },
  button: {
    fontSize: theme.typography.pxToRem(11),
    width: 160,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(14),
      width: 200,
    },
  },
}));

const Header = ({ authenticated }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Link href={HOME}>
        <img
          src={LogoText}
          alt="おてつたびトップページ"
          className={classes.logoText}
        />
      </Link>
      <div className={classes.buttonContainer}>
        <ServiceButton
          classes={{ root: clsx(classes.buttonLeft, classes.button) }}
          href={process.env.OFFICIAL_LINE_DIRECT_URL}
          target="_blank"
          rel="noreferrer"
        >
          LINEをお友達登録
        </ServiceButton>
        <ServiceButton
          classes={{ root: classes.button }}
          href={authenticated ? HOME : SIGN_UP}
        >
          おてつたびに会員登録
        </ServiceButton>
      </div>
    </div>
  );
};

export default Header;
